<!-- 
Contents of the RISK PROFILE tab of the provider page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="arrivedFromListing"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      user-guide-topic="listing-providers"
      user-guide-section="risk-profile"
      module="providers"
      nav-url="/providers/:id/risk-profile"
    />
    <tabs :provider-id="providerId" :incomplete-contacts="incompleteContacts">
      <v-container fluid grid-list-md class="pa-2 pt-3 pb-3">
        <v-layout row wrap>
          <provider-risk-profile-chart :provider-id="providerId" levy-collection-type="Help"/>
          <provider-risk-profile-chart :provider-id="providerId" levy-collection-type="Vsl"/>
          <provider-risk-profile-chart :provider-id="providerId" levy-collection-type="Upfront"/>
        </v-layout>
      </v-container>
    </tabs>
  </div>
</template>

<script>
import ProviderRiskProfileChart from "@/components/providers/ProviderRiskProfileChart.vue";
import providerMixins from "./mixins";
import Tabs from "./Tabs.vue";

export default {
  name: "ProviderSummary",
  components: { ProviderRiskProfileChart, Tabs },
  mixins: [providerMixins]
};
</script>
